(function () {
  'use strict';

  // Set to false to disable the pre-checkout OTP verification gate.
  var PRECHECKOUT_OTP_ENABLED = true;
  if (!PRECHECKOUT_OTP_ENABLED) return;

  var API_BASE = (window.PRECHECKOUT_API_URL || 'https://amiybook.netlify.app/.netlify/functions').replace(/\/$/, '');
  var STORAGE_KEY = 'amiy_precheckout_ok';
  var SESSION_MS = 30 * 60 * 1000;
  var bypassOnce = false;
  var pendingAction = null;
  var currentPhone = '';

  var root = document.getElementById('PreCheckoutGate');
  if (!root) return;

  var phoneStep = root.querySelector('[data-precheckout-step="phone"]');
  var otpStep = root.querySelector('[data-precheckout-step="otp"]');
  var phoneInput = root.querySelector('[data-precheckout-phone]');
  var otpInput = root.querySelector('[data-precheckout-otp]');
  var phoneError = root.querySelector('[data-precheckout-error-phone]');
  var otpError = root.querySelector('[data-precheckout-error-otp]');
  var phoneDisplay = root.querySelector('[data-precheckout-phone-display]');
  var continueBtn = root.querySelector('[data-precheckout-continue]');
  var verifyBtn = root.querySelector('[data-precheckout-verify]');
  var resendBtn = root.querySelector('[data-precheckout-resend]');
  var backBtn = root.querySelector('[data-precheckout-back]');

  function digitsOnly(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function normalizePhone(value) {
    var d = digitsOnly(value);
    if (d.length === 12 && d.indexOf('91') === 0) d = d.slice(2);
    if (d.length === 11 && d.charAt(0) === '0') d = d.slice(1);
    if (d.length === 10 && /^[6-9]/.test(d)) return d;
    return null;
  }

  function isGatePassed() {
    // Signed in on /pages/my-account (amiy-auth.js): phone already verified
    if (window.AmiyAuth && window.AmiyAuth.account()) return true;
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (!data || !data.exp || Date.now() > data.exp) {
        sessionStorage.removeItem(STORAGE_KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;
    }
  }

  function markGatePassed(phone) {
    if (window.AmiyAuth && phone) window.AmiyAuth.remember(phone);
    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ phone: phone || '', exp: Date.now() + SESSION_MS })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function setError(el, msg) {
    if (el) el.textContent = msg || '';
  }

  function setLoading(btn, loading, label) {
    if (!btn) return;
    if (loading) {
      btn.dataset.prevLabel = btn.textContent;
      btn.textContent = label || 'Please wait…';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.prevLabel || btn.textContent;
      btn.disabled = false;
    }
  }

  function showStep(name) {
    if (phoneStep) phoneStep.hidden = name !== 'phone';
    if (otpStep) otpStep.hidden = name !== 'otp';
  }

  function openGate(action) {
    pendingAction = action || null;
    currentPhone = '';
    if (phoneInput) phoneInput.value = '';
    if (otpInput) otpInput.value = '';
    setError(phoneError, '');
    setError(otpError, '');
    showStep('phone');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (phoneInput) setTimeout(function () { phoneInput.focus(); }, 50);
  }

  function closeGate() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    pendingAction = null;
  }

  function resumePending() {
    var action = pendingAction;
    pendingAction = null;
    closeGate();
    if (!action) return;

    bypassOnce = true;
    try {
      if (action.type === 'form-submit' && action.form) {
        if (typeof action.form.requestSubmit === 'function') {
          action.form.requestSubmit(action.submitter || undefined);
        } else {
          action.form.submit();
        }
      } else if (action.type === 'click' && action.element) {
        action.element.click();
      } else if (action.type === 'flo' && typeof window.handleFloBuyNowBtn === 'function') {
        window.handleFloBuyNowBtn(action.event || { preventDefault: function () {}, stopPropagation: function () {} });
      }
    } finally {
      setTimeout(function () { bypassOnce = false; }, 0);
    }
  }

  function apiPost(path, payload) {
    return fetch(API_BASE + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {}),
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { status: res.status, ok: res.ok, data: data };
      });
    });
  }

  function showOtpStep(phone) {
    currentPhone = phone;
    if (phoneDisplay) phoneDisplay.textContent = phone;
    if (otpInput) otpInput.value = '';
    setError(otpError, '');
    showStep('otp');
    if (otpInput) setTimeout(function () { otpInput.focus(); }, 50);
  }

  function onContinue() {
    var phone = normalizePhone(phoneInput && phoneInput.value);
    if (!phone) {
      setError(phoneError, 'Enter a valid 10-digit Indian mobile number.');
      return;
    }
    setError(phoneError, '');
    setLoading(continueBtn, true, 'Checking…');

    apiPost('/storefront-checkout-gate', { phone: phone })
      .then(function (result) {
        setLoading(continueBtn, false);
        var data = result.data || {};
        if (data.proceed === true) {
          markGatePassed(data.phone || phone);
          resumePending();
          return;
        }
        if (data.otp_required) {
          if (result.status === 429 && data.error === 'cooldown') {
            showOtpStep(phone);
            setError(
              otpError,
              data.retry_after_sec
                ? 'Code already sent. Wait ' + data.retry_after_sec + 's to resend, or enter the code.'
                : 'Code already sent. Enter it below, or wait to resend.'
            );
            return;
          }
          if (!result.ok) {
            setError(phoneError, data.error === 'sms_not_configured' || data.error === 'sms_failed'
              ? 'Could not send SMS. Please try again.'
              : String(data.error || 'Unable to send code.'));
            return;
          }
          showOtpStep(phone);
          return;
        }
        setError(phoneError, data.error || 'Unable to verify. Please try again.');
      })
      .catch(function () {
        setLoading(continueBtn, false);
        setError(phoneError, 'Network error. Please try again.');
      });
  }

  function onVerify() {
    var code = digitsOnly(otpInput && otpInput.value);
    if (!/^\d{6}$/.test(code)) {
      setError(otpError, 'Enter the 6-digit code from SMS.');
      return;
    }
    setError(otpError, '');
    setLoading(verifyBtn, true, 'Verifying…');

    apiPost('/storefront-verify-otp', { phone: currentPhone, code: code })
      .then(function (result) {
        setLoading(verifyBtn, false);
        var data = result.data || {};
        if (data.proceed === true) {
          markGatePassed(data.phone || currentPhone);
          resumePending();
          return;
        }
        var msg = 'Invalid code. Please try again.';
        if (data.error === 'too_many_attempts') msg = 'Too many attempts. Request a new code.';
        else if (data.error === 'otp_not_found') msg = 'Code expired. Request a new one.';
        else if (typeof data.attempts_remaining === 'number') {
          msg = 'Invalid code. ' + data.attempts_remaining + ' attempts left.';
        }
        setError(otpError, msg);
      })
      .catch(function () {
        setLoading(verifyBtn, false);
        setError(otpError, 'Network error. Please try again.');
      });
  }

  function onResend() {
    if (!currentPhone) return;
    setError(otpError, '');
    setLoading(resendBtn, true, 'Sending…');
    apiPost('/storefront-checkout-gate', { phone: currentPhone })
      .then(function (result) {
        setLoading(resendBtn, false);
        var data = result.data || {};
        if (data.proceed === true) {
          markGatePassed(data.phone || currentPhone);
          resumePending();
          return;
        }
        if (result.status === 429) {
          setError(
            otpError,
            data.retry_after_sec
              ? 'Please wait ' + data.retry_after_sec + 's before resending.'
              : 'Please wait before resending.'
          );
          return;
        }
        if (!result.ok) {
          setError(otpError, 'Could not resend code. Please try again.');
          return;
        }
        setError(otpError, 'A new code was sent.');
      })
      .catch(function () {
        setLoading(resendBtn, false);
        setError(otpError, 'Network error. Please try again.');
      });
  }

  function isCheckoutButton(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('button[name="checkout"], input[name="checkout"]');
    if (btn) return btn;
    return null;
  }

  function isFloBuyNow(el) {
    if (!el || !el.closest) return null;
    return el.closest('[data-flo-buy-now], [name="flo-buy-now-button"], [id^="flo-buy-now-button"]');
  }

  function shouldBypass() {
    return bypassOnce || isGatePassed();
  }

  function onDocumentClick(event) {
    if (shouldBypass()) return;

    var flo = isFloBuyNow(event.target);
    if (flo) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openGate({ type: 'click', element: flo });
      return;
    }

    var checkoutBtn = isCheckoutButton(event.target);
    if (checkoutBtn) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      var form = checkoutBtn.form || checkoutBtn.closest('form');
      openGate({ type: 'form-submit', form: form, submitter: checkoutBtn });
    }
  }

  function onFormSubmit(event) {
    if (shouldBypass()) return;
    var form = event.target;
    if (!form || !form.matches) return;
    if (!form.matches('[data-cart-form], #cartForm, form[action*="/cart"]')) return;

    var submitter = event.submitter;
    var isCheckout =
      (submitter && submitter.name === 'checkout') ||
      (form.querySelector && form.querySelector('button[name="checkout"], input[name="checkout"]'));
    if (!isCheckout) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    openGate({ type: 'form-submit', form: form, submitter: submitter || null });
  }

  function wrapFloHandler() {
    if (typeof window.handleFloBuyNowBtn !== 'function') return;
    if (window.handleFloBuyNowBtn.__amiyGateWrapped) return;
    var original = window.handleFloBuyNowBtn;
    function wrapped(event) {
      if (shouldBypass()) return original.call(this, event);
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      if (event && typeof event.stopPropagation === 'function') event.stopPropagation();
      openGate({ type: 'flo', event: event });
    }
    wrapped.__amiyGateWrapped = true;
    wrapped.__amiyOriginal = original;
    window.handleFloBuyNowBtn = wrapped;
  }

  root.querySelectorAll('[data-precheckout-close]').forEach(function (el) {
    el.addEventListener('click', function () { closeGate(); });
  });

  if (continueBtn) continueBtn.addEventListener('click', onContinue);
  if (verifyBtn) verifyBtn.addEventListener('click', onVerify);
  if (resendBtn) resendBtn.addEventListener('click', onResend);
  if (backBtn) {
    backBtn.addEventListener('click', function () {
      showStep('phone');
      setError(otpError, '');
    });
  }

  if (phoneInput) {
    phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        onContinue();
      }
    });
  }
  if (otpInput) {
    otpInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        onVerify();
      }
    });
  }

  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('submit', onFormSubmit, true);

  wrapFloHandler();
  var floPoll = setInterval(function () {
    wrapFloHandler();
  }, 1000);
  setTimeout(function () { clearInterval(floPoll); }, 20000);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) closeGate();
  });
})();
